import {useErrorLogger} from '@shopify/react-bugsnag';
import {MonorailEvent, trackEvent} from '../../utils/monorail.client';
import {ShoppingBagEvent} from '../../utils/shoppingBagAnalytics';

type RecordClickEventProps = {
  event: MonorailEvent.TrackShoppingBag;
  eventType?: ShoppingBagEvent;
  data: unknown;
  children: React.ReactNode;
};

export const RecordClickEvent = (props: RecordClickEventProps) => {
  const {event, eventType, data, children} = props;

  const logger = useErrorLogger();

  return (
    <div
      onClick={() => {
        // @ts-expect-error TODO: correct typings for data
        trackEvent({event, eventType, data})?.catch((error) => {
          let eventInfo: string = event;
          if (eventType) {
            eventInfo += ` / ${eventType}`;
          }
          logger.notify(
            new Error(`event tracking error: ${eventInfo}: ${error}`),
          );
        });
      }}
    >
      {children}
    </div>
  );
};
